module.exports = __webpack_public_path__ + "static/key-autonauts-8aaf9c807624c769d3e7910ccace6e8e.webp";